<div id="columMap" class="columMap">
    <!-- Map container element -->
    <div #mapContainer id="mainMap" class="mainMap"></div>
</div>
